/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconReverse: {
  name: 'reverse';
  data: string;
} = {
  name: 'reverse',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M300.91 594.129 599.205 522.575 512.12 228.826 446.417 342.458 380.789 304.623 413.024 249.028 217.02 136.226 266.366 51.125 42.34 104.714 107.743 324.7 107.743 324.704 157.085 239.606 223.499 277.828 171.387 367.955 366.61 480.499 300.912 594.126z"/></svg>`,
};
